import apiClient from '../helpers/apiClient'

/**
 * Lado del COMPRADOR: buscar expertos y sus servicios, y solicitar uno.
 *
 * Aparte de `expertiseAdminService`, que sirve al panel de admin y al portal del experto. Aqui
 * todo es lo que un miembro cualquiera puede ver: solo servicios ya aprobados y partners activos.
 */

export interface PublicExpert {
  id: number
  companyName: string
  description: string | null
  address: string | null
  logo: string | null
  /** El usuario detras del partner: con quien se abre el chat. */
  userId: number | null
  expertiseCount: number
}

export interface PublicExpertiseService {
  id: number
  title: string
  description: string
  hourlyRate: string | null
  price: string | null
  /** La tarifa que aplique segun la modalidad; llega como string (DecimalField). */
  rate: string | null
  /** Sufijo a la derecha de la tarifa: "Hour", "Project"... */
  rateUnit: string | null
  currency: string
  modality: string
  modalityDisplay: string
  scheduleOn: string | null
  partner: PublicExpert | null
}

type SearchParams = {where?: string; keywords?: string; limit?: number; offset?: number}

/** Las vistas paginan; el buscador solo necesita la lista. */
const unwrap = (data: any) => (Array.isArray(data) ? data : data?.results ?? [])

export const searchExpertiseServices = async (
  params: SearchParams = {}
): Promise<PublicExpertiseService[]> => {
  const {data} = await apiClient.get('/expertise/search/services/', {params})
  return unwrap(data)
}

export const searchExperts = async (params: SearchParams = {}): Promise<PublicExpert[]> => {
  const {data} = await apiClient.get('/expertise/search/experts/', {params})
  return unwrap(data)
}

export const getExpertProfile = async (partnerId: number | string): Promise<PublicExpert> => {
  const {data} = await apiClient.get(`/expertise/experts/${partnerId}/profile/`)
  return data
}

export const getExpertServices = async (
  partnerId: number | string
): Promise<PublicExpertiseService[]> => {
  const {data} = await apiClient.get(`/expertise/experts/${partnerId}/services/`)
  return unwrap(data)
}

export interface BookExpertisePayload {
  /** ISO. Fecha en que el comprador quiere la sesion. */
  scheduledOn: string
  /** Horas contratadas: es el factor que define el monto del paso 1. */
  hours: number
  message?: string
}

/** Manda la solicitud. A partir de aqui arranca el timeline de 5 pasos en /messages. */
export const bookExpertise = async (serviceId: number, payload: BookExpertisePayload) => {
  const {data} = await apiClient.post(`/expertise/services/${serviceId}/request/`, payload)
  return data
}
